import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import axios from 'axios';
import config from '../configuration/config';
import { toast } from "react-toastify";
import { getData, User_Data_Key } from "../utils/localStorageManager";

export function OfferDetail({ desc, terms, slug, offerId, handleActicePackage }) {
    const { t: trans, i18n } = useTranslation(["offers", "common", "error", "info", "extra", "global"]);
    const history = useHistory();
    let lang = (i18n.language || 'ar');
    const languageDir = 'language-' + lang;
    const [indexPanel, setIndexPanel] = useState("1000");
    const [isDescExpanded, setIsDescExpanded] = useState(false);

    const handleOrderRequest = async () => {
        const _isLogin = getData('isAuthenticated');
        if (_isLogin) {
            const userData = JSON.parse(getData(User_Data_Key, true));
            const userId = userData.id.toString().split('_')[1];
            const response = await axios.post(
                `${config.controllURL}${lang}/api/Pages/DetailsSiteOfferReservation`,
                {
                    "ObjectSettings": {
                        "MetaData": false
                    },
                    "Filters": `where offerId = ${offerId}  and userId = ${userId}`
                });

            if (response.status === 200) {
                if (response.data.ApiObjectData.length !== 0) {
                    toast.error(trans("common:request-repeated"));
                } else {
                    axios.post(
                        `${config.controllURL}${lang}/api/Pages/AddSiteOfferReservation`,
                        {
                            "UserID": Number(userId),
                            "OfferID": offerId,
                            "DescriptionAr": userData.descriptionAr,
                            "DescriptionEn": userData.descriptionEn,
                            "Email": userData.email,
                            "Phone": userData.phone
                        }
                    ).then((response) => {
                        toast.success(trans("common:order-request-success"));
                    }).catch((err) => {
                        if (err.response && err.response.status === 400) {
                            toast.error(trans("error:unknown_failure"));
                        }
                    });
                }
            }
            return;
        }
        history.push("/offers/order/" + slug);
    };

    return (
        <div className={"offer-detail  nice-shadow-0 " + languageDir}>
            <div className="offer-detail-info clearfix">
                {
                    desc &&
                    <div className="panel-section panel-white bg-theme-up mb-4">
                        <div className="panel-content-body block p-0">
                            <div className="mx-10 my-10">
                                <div className={`offer-desc text-20 leading-relaxed ${!isDescExpanded ? "clamped" : ""}`}>
                                    {desc.split("\n").map((item, idx) => (
                                        item?.trim() && <p key={idx} className="offer-desc-item">{item}</p>
                                    ))}
                                </div>
                                {desc.split("\n").filter(i => i.trim()).length > 2 && (
                                    <button
                                        className={`show-more-btn mt-4 ${isDescExpanded ? "expanded" : ""}`}
                                        onClick={() => setIsDescExpanded(!isDescExpanded)}
                                    >
                                        {isDescExpanded ? trans("common:show-less") : trans("common:show-more")}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                }

                {
                    terms &&
                    <div className="panel-section panel-white bg-theme-up">
                        <div className={`panel-content   ${(indexPanel === "2000") ? "show-panel-info" : ""}`}>
                            <div className="panel-content-top px-5"
                                onClick={(e) => setIndexPanel(indexPanel === "2000" ? "000" : "2000")}
                            >
                                <h1 className="text-30   text-super-gray font-bold">{trans("offers:terms")}</h1>
                                <img src="/assets/icons/arrow.svg" alt="arrow" />
                            </div>

                            <div className="panel-content-body">
                                <div className="mx-10 my-10">
                                    {
                                        terms ?
                                            <div className={"new-lines offer-detail-data"}>
                                                <ul>
                                                    {
                                                        terms?.split('\n')?.map((item, index) => {
                                                            return (
                                                                item && item.trim().toString() &&
                                                                <li className={"text-20 font-bold"} key={index}>
                                                                    {item}
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}
